var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwentyfourHOpenMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44,22c0-11.0283203-8.9716797-20-20-20S4,10.9716797,4,22c0,8.9383545,5.8947144,16.5229492,14,19.0776367V38.949707 C11.0205688,36.4707031,6,29.8187256,6,22c0-9.9248047,8.0751953-18,18-18s18,8.0751953,18,18s-8.0751953,18-18,18 c-0.1882324,0-0.3707886-0.0224609-0.5576782-0.0283203l3.2647095-3.2646484l-1.4140625-1.4140625L22,38.5859375 l-1.7070312,1.7070312c-0.390625,0.390625-0.390625,1.0234375,0,1.4140625L21.5859375,43l3.7070312,3.7070312l1.4140625-1.4140625 L23.3828125,41.96875C23.5896606,41.9750977,23.791687,42,24,42C35.0283203,42,44,33.0283203,44,22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7851562,21.5996094C15.6533203,22.7919922,13,24.2773438,13,28c0,0.5527344,0.4472656,1,1,1h9v-2h-7.8974609 c0.4003906-1.8320312,1.9287109-2.6865234,3.6591797-3.6552734C20.7480469,22.2324219,23,20.9726562,23,18 c0-2.7568359-2.2431641-5-5-5s-5,2.2431641-5,5h2c0-1.6542969,1.3457031-3,3-3s3,1.3457031,3,3 C21,19.7128906,19.7783203,20.4833984,17.7851562,21.5996094z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3486328,13c-0.5537109,0-1.0673828,0.2744141-1.3740234,0.7353516l-5.6777344,8.5166016 C24.1025391,22.5429688,24,22.8818359,24,23.2324219C24,24.2070312,24.7929688,25,25.7675781,25H31v4h2v-4h3v-2h-3v-8.3486328 C33,13.7412109,32.2587891,13,31.3486328,13z M31,23h-4.7978516L31,15.8027344V23z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwentyfourHOpenMedium);
export default __webpack_public_path__ + "static/media/twentyfour-h-open--medium.431d2dd438dafd2b83b5bc216f596196.svg";
export { ForwardRef as ReactComponent };